import axios from "axios";
import loadConfig from "@tonWalletConfig/config";
import store from "@store/index";
import CryptoJS from "crypto-js"; // ⚠️ 用这个
const crypto = require("crypto");
import requestApiCache from "@assets/js/requestApiCache";
import qs from "qs";

const Axios = axios.create({
  timeout: 30000,
});

Axios.defaults.baseURL = loadConfig.http_host;

// ================= 缓存配置 =================
const cacheConfig = {
  "/task/list": { duration: 15000, cacheEnabled: true },
  "/game/property/list": { duration: 30000, cacheEnabled: true },
  "/ranking/topleaders": { duration: 30000, cacheEnabled: true },
  "/ranking/friend": { duration: 30000, cacheEnabled: true },
  "/lucky/spins/prices": { duration: 60000, cacheEnabled: true },
  "/ranking/personal": { duration: 30000, cacheEnabled: true },
  "/mining/storage/prices": { duration: 60000, cacheEnabled: true },
  "/game/cipher/ranking": { duration: 60000, cacheEnabled: true },
  "/game/cipher/prices": { duration: 60000, cacheEnabled: true },
  "/game/cipher/invitation/logs": { duration: 60000, cacheEnabled: true },

  "/rank/activity/list": { duration: 15000, cacheEnabled: true },
  "/rank/activity/items": { duration: 15000, cacheEnabled: true },
  "/rank/activity/ranking": { duration: 15000, cacheEnabled: true },
};

// ================= 工具函数 =================

// 生成稳定 cacheKey
function generateStableKey(url, data = {}) {
  const sorted = JSON.stringify(data, (key, value) => {
    if (key === "time") return undefined; // 排除时间字段
    if (typeof value === "object" && value !== null) {
      return Object.keys(value)
        .sort()
        .reduce((res, k) => {
          res[k] = value[k];
          return res;
        }, {});
    }
    return value;
  });

  const hash = crypto.createHash("sha256");
  hash.update(url + sorted);
  return hash.digest("hex");
}

// ================= 🔐 aesEncrypt 实现 =================

function _x(str) {
  return str.split('').map(c => c.charCodeAt(0) + 1)
    .map(n => String.fromCharCode(n - 1))
    .join('');
}

const _a = _x("jd");    
const _b = _x("hxq");
const _c = _x("ya");
const _d = _x("gzx");
const _e = _x("jf");
const _f = _x("0cy3");

function getK1() { return [_a, _b].join(""); }
function getK2() { return [_c, _d].join(""); }
function getK3() { return [_e, _f].join(""); }

function aesEncrypt(data) {
  const k1 = getK1();
  const k2 = getK2();
  const k3 = getK3();

  const KEY = CryptoJS.enc.Utf8.parse(k1 + k3 + k2);
  const IV = CryptoJS.enc.Utf8.parse(k2 + k1 + k3);

  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    KEY,
    {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  ).toString();
}

// 👉 包装成请求格式
function aesEncryptWrapper(data, token) {
  const originalData = JSON.stringify({ ...data, time: new Date().getTime() });
  console.log("originalData666", originalData);
  return {
    data: aesEncrypt(originalData),
    _token: token,
  };
}

// [] => 所有接口不加密
// "all" => 所有接口加密
// array => 只有列表中的接口加密
let encryptWhiteList = ["/task/complete"];

function shouldEncrypt(url) {
  if (!encryptWhiteList || encryptWhiteList.length === 0) return false;
  if (encryptWhiteList === "all" || (encryptWhiteList.length === 1 && encryptWhiteList[0] === "all")) return true;
  return encryptWhiteList.includes(url);
}

// ================= 请求拦截 =================
Axios.interceptors.request.use(
  (config) => {
    const token = store.state["user"]["token"] || "";
    const url = config.url;

    config.maxBodyLength = Infinity;
    config.headers["Content-Type"] = "application/json";

    // ====== 缓存 ======
    const cacheOptions = cacheConfig[url] || { cacheEnabled: false };
    let cacheKey = null;

    if (cacheOptions.cacheEnabled && config.method === "post") {
      cacheKey = generateStableKey(url, config.data);
      const cachedData = requestApiCache.getCache(cacheKey, cacheOptions.duration);

      if (cachedData) {
        const controller = new AbortController();
        config.signal = controller.signal;
        controller.abort();

        return Promise.reject(
          new axios.Cancel(`${url}-||-${cacheKey}-||-${JSON.stringify(cachedData)}`)
        );
      }
    }

    // ====== 白名单加密逻辑 ======
    if (shouldEncrypt(url)) {
      config.data = aesEncryptWrapper(config.data || {}, token);
      console.log("config.data666666", config.data);
    } else {
      if (token) {
        config.data = { ...config.data, _token: token };
      }else {
         config.data = { ...config.data };
      }
    }

    config.__cacheKey = cacheKey;
    return config;
  },
  (error) => Promise.reject(error)
);

// ================= 响应拦截 =================
Axios.interceptors.response.use(
  (res) => {
    const url = res.config.url;
    const cacheOptions = cacheConfig[url] || { cacheEnabled: false };
    if (cacheOptions.cacheEnabled && res.config.method === "post") {
      const cacheKey = res.config.__cacheKey;
      if (cacheKey) {
        requestApiCache.setCache(cacheKey, res.data, cacheOptions.duration);
      }
    }
    return res.data;
  },
  (err) => {
    // **如果请求被取消（因缓存命中），解析缓存数据并返回**
    if (axios.isCancel(err)) {
      const match = err.message.split("-||-");
      if (match && match[2]) {
        try { return Promise.resolve(JSON.parse(match[2])); } catch (e) { }
      }
      return Promise.resolve(null);
    }
    // 检查是否是网络问题
    console.log("window.navigator.onLine", window.navigator.onLine);
    if (!window.navigator.onLine) {
      // 处理重试逻辑
      let retryCount = err?.config?.retryCount || 0;
      const maxRetries = 2;

      function retryRequest() {
        console.log(88888888);
        if (loadConfig.ext_http_host.constructor === Array) {
          let idx = Math.floor(Math.random() * loadConfig.ext_http_host.length);
          err.config.baseURL = loadConfig.ext_http_host[idx];
        } else {
          err.config.baseURL = loadConfig.ext_http_host;
        }
        console.log(9999999);

        return new Promise((resolve, reject) => {
          setTimeout(() => {
            console.log(`Retry count: ${retryCount + 1}`);
            if (retryCount >= maxRetries) {
              return Promise.resolve(err);
            } else {
              retryCount++;
              let newConfig = { ...err.config, retryCount };
              newConfig.data = qs.parse(newConfig.data); // Ensure data is parsed
              Axios(newConfig).then(resolve).catch(reject);
            }
          }, 1000); // Wait 1 second before retry
        });
      }

      return retryRequest();
    }
  }
);

// ================= 清缓存 =================
function clearCacheForUrl(url, params = {}) {
  const cacheKey = generateStableKey(url, params);
  requestApiCache.clearCache(cacheKey);
}

// ================= Vue挂载 =================
export default {
  install: (Vue) => {
    Object.defineProperty(Vue.prototype, "$http", { value: Axios });
    Object.defineProperty(Vue.prototype, "$httpClear", { value: clearCacheForUrl });
  },
  Axios,
  clearCacheForUrl,
  setEncryptWhiteList: (list) => { encryptWhiteList = list; }, // 外部可动态修改白名单
};